import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Item(data){
  const {title, img} = data;
  return(
    <div className="expertise-item">
      <div className="image text-center">
        <img src={img} alt={title}/>
      </div>
      <div className="text">
        <h4 className="title">{title}</h4>
      </div>                   
    </div>

  )
}

function Expertise() {
  const skill = {
    unity:{
      title: "Unity", img: "assets/img/unity-dark.png"
    },
    unreal:{
      title: "Unreal", img: "assets/img/unreal.png"
    },
    blender:{
      title: "Blender", img: "assets/img/blender.png"
    },
    arduino:{
      title: "Arduino", img: "assets/img/arduino.png"
    },
    nodejs:{
      title: "NodeJS", img: "assets/img/nodejs.png"
    },
    bootstrap:{
      title: "Bootstrap", img: "assets/img/bootstrap.png"
    },
    react:{
      title: "React", img: "assets/img/react.png"
    },
    mysql:{
      title: "MySql", img: "assets/img/mysql.png"
    },
  }
  return (
    <Card className='expertise-card'>
      <Card.Body>
        <Card.Title as="h3">My Expertise</Card.Title>
        <div className='expertise-container'>
          <Row className='g-3'>
            <Col xl={4} md={4} sm={6}>{Item(skill.unity)}</Col>
            <Col xl={4} md={4} sm={6}>{Item(skill.unreal)}</Col>
            <Col xl={4} md={4} sm={6}>{Item(skill.blender)}</Col>
            <Col xl={4} md={4} sm={6}>{Item(skill.arduino)}</Col>
            <Col xl={4} md={4} sm={6}>{Item(skill.nodejs)}</Col>
            <Col xl={4} md={4} sm={6}>{Item(skill.bootstrap)}</Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
}
// import styles from '../App.module.css';
// const Expertise = ()=>{
//    return(
//       <>
//          <h3 class="card-title">My Expert Area</h3>
//          <div class="expertise-main mt-24">
//             <div class="row g-3">
//                <div class="col-xl-4 col-md-4 col-sm-6 col-6">
//                   <div class="expertise-item">
//                      <div class="image text-center">
//                         <img src="assets/img/icons/figma.svg" alt="Figma"/>
//                      </div>
//                      <div class="text">
//                         <h4 class="title">Figma</h4>
//                      </div>
//                   </div>
//                </div>
//                <div class="col-xl-4 col-md-4 col-sm-6 col-6">s
//                   <div class="expertise-item">
//                      <div class="image text-center">
//                         <img src="assets/img/icons/notion.svg" alt="Notion"/>
//                      </div>
//                      <div class="text">
//                         <h4 class="title">Notion</h4>
//                      </div>
//                   </div>
//                </div>
//             </div>
//          </div>
//       </>
//    );
// }
 export default Expertise;